<form>
  <div class="flex w-full flex-col justify-start gap-3 xs:gap-4 sm:gap-6 lg:gap-8">
    <div class="relative">
      <pay-input [formControl]="this.form.controls.email" [id]="'email'" [label]="'reset-password.input.email.label' | translate" type="email" />
    </div>
    @if (this.error) {
      <pay-login-error-badge [error]="this.error!" />
    }
    <pay-button-primary (click)="submit()" [loading]="isSubmitting" [disabled]="this.form.invalid && this.form.touched" [rounded]="'rounded-lg'">
      {{ 'reset-password.button-reset-password.label' | translate }}
    </pay-button-primary>
    <div class="flex gap-3 self-center">
      <span class="text-center text-neutral-80">
        {{ 'reset-password.back-login.description' | translate }}
        <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
          {{ 'reset-password.back-login.label' | translate }}
        </span>
      </span>
    </div>
  </div>
</form>
